import { commonApi } from '@common/utils/baseQuery';
import {
  IExactScoreResponse,
  ISuperExactScoreBonus,
  ISuperExactScoreRequest,
  ISuperExactScoreResponse,
} from './superExactScore.type';

const superExactScoreApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    getSuperExactScore: builder.query<ISuperExactScoreResponse, void>({
      query: () => ({
        url: '/exactscore',
      }),
    }),
    getSuperExactScoreBonus: builder.query<ISuperExactScoreBonus[], void>({
      query: () => ({
        url: '/exactscore/bonus',
      }),
    }),
    superExactScoreMakeBet: builder.mutation<IExactScoreResponse, ISuperExactScoreRequest>({
      query: (data) => ({
        url: '/exactscore/bets',
        body: data,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetSuperExactScoreQuery, useGetSuperExactScoreBonusQuery, useSuperExactScoreMakeBetMutation } = superExactScoreApi;
